import casual from '../../mockedTypes';

const resolvers = {};

const schemaExtensionResolvers = {
  SGContent: {
    partner: () => casual.partner,
    thematic: () => casual.thematic,
  },
  SGDocument: {
    partner: () => casual.partner,
    thematic: () => casual.thematic,
  },
};

export { resolvers, schemaExtensionResolvers };
